import LocalStorageService from "@/common/LocalStorageService";

const localStorageService = LocalStorageService.getService();

export const orderTypeService = {
    isAmendType() {
        return localStorageService.getOrderType() && localStorageService.getOrderType() === 'A'
    },
    isNonAmendType() {
        return localStorageService.getOrderType() && localStorageService.getOrderType() === 'N'
    },
    isTypeSet() {
        return !!localStorageService.getOrderType()
    }
}